const relay = {
    origin: '*',
    accept (event) {
        if (event.source !== window.parent) return false;
        if (this.origin === '*' && /^https?:\/\//.test(event.origin)) {
            this.origin = event.origin;
        }
        return this.origin === '*' || event.origin === this.origin;
    },
    post (message) {
        window.parent.postMessage(message, this.origin);
    }
};

export default relay;
